import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";

function Footer() {
  return (
    <footer className="bg-gray-100 text-gray-700 mt-16 pt-10 pb-6">
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* 회사 로고 + 설명 */}
        <div>
          <div className="flex items-center space-x-2 mb-3">
            <img src="/logo.png" alt="JDWinTech Logo" className="w-10 h-10" />
            <span className="text-lg font-bold text-blue-600">JDWinTech</span>
          </div>
          <p className="text-sm">
            스마트 공조 및 배연창 설비 분야를 선도하는 JDWinTech입니다.  
            효율적이고 안전한 솔루션으로 고객과 함께 성장합니다.
          </p>
        </div>

        {/* 페이지 링크 */}
        <div>
          <h4 className="text-md font-semibold mb-3">사이트 맵</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/company" className="hover:text-blue-600">회사소개</Link></li>
            <li><Link to="/products" className="hover:text-blue-600">제품소개</Link></li>
            <li><Link to="/solutions" className="hover:text-blue-600">솔루션</Link></li>
            <li><Link to="/references" className="hover:text-blue-600">레퍼런스</Link></li>
            <li><Link to="/news" className="hover:text-blue-600">뉴스</Link></li>
            <li><Link to="/contact" className="hover:text-blue-600">문의하기</Link></li>
          </ul>
        </div>

        {/* 연락처 / 주소 */}
        <div>
          <h4 className="text-md font-semibold mb-3">연락처</h4>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center space-x-2">
              <Phone size={16} /> <span>02-123-4567</span>
            </li>
            <li className="flex items-center space-x-2">
              <Mail size={16} /> <span>info@jdwintech.com</span>
            </li>
            <li className="flex items-center space-x-2">
              <MapPin size={16} /> <span>서울특별시 송파구 중대로 123</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Copylight */}
      <div className="text-center text-xs text-gray-500 mt-10">
        &copy; {new Date().getFullYear()} JDWinTech. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;